export default __webpack_public_path__ + "static/media/rounded-car-3x.a6b729ee.webp";